<template>
  <li>
    <span class="module-title"><router-link :to="'/a/module/' + module.id">{{ module.title }}</router-link></span>
    <span class="module-options">
      <router-link title="Edit Module" :to="'/a/module/' + module.id" class="edit"><span><i class="icon icon-edit"></i></span></router-link>
      <span title="Make a Copy"><i class="icon icon-doc-copy" @click="duplicate()"></i></span>
      <span title="Delete Module"><i class="icon icon-trash" @click="deleteModule()"></i></span>
    </span>
  </li>
</template>

<script>
  export default {
    props: ['module'],
    methods: {
      duplicate() {
        var vm = this;
        var clone = _.clone(vm.module);
        clone.title += ' (Copy)';

        axios.post('/api/module', clone)
        .then(response => {
          vm.$router.push('/a/module/' + response.data.id);
        });
      },
      deleteModule() {
        var vm = this;

        Events.$emit('alertModal', {
          body: vm.$t('modules.confirm_archive', { module_title: vm.module.title }),
          actions: ['Yes', 'No'],
          done: function(action) {
            if (action === 'Yes') {
              axios.delete('/api/module/' + vm.module.id)
                .then(response => {
                  vm.$emit('delete', vm.module);
                });
            }
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  li {
    position: relative;
    background: $white;
    box-shadow: 0 2px 13px 1px rgba(211, 215, 221, 0.50);
    border-radius: 5px;
    min-height: 60px;
    height: 60px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid $white;
    padding: 0 30px;
    line-height: 2px;

    .module-title {
      width: 70%;
      a {
        color: $grey;
        &:hover {
          cursor: pointer;
          color: $green;
        }
      }
    }
    .module-options {
      width: 30%;
      opacity: 0;
      text-align: right;
      span {
        margin-left: 10px;
        color: $mutedblue;
      }
      .edit {
        i {
          margin-top: 1px;
          margin-right: 2px;
        }
      }
    }
    &:hover {
      border-color: $green;
      .module-options {
        opacity: 1;
        span {
          &:hover {
            color: $green;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// module-line-item.vue?5d3445fe